
import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";

export class ObavijestiPoker extends React.Component {



    constructor(props) {
        super(props);
        this.state = { pravilaOznacena: false, pravilaJednomOznacena: false }


        this.const_PokerStart = "PokerStart"

        this.sakrijObavijest = this.sakrijObavijest.bind(this);
        this.togglePravila = this.togglePravila.bind(this);

    }


    sakrijObavijest(naziv) {
        if (this.state.pravilaOznacena) {
            this.props.sakrijObavijestFn(naziv);
        }
    }
    togglePravila() {
        var pravilaSelected = !this.state.pravilaOznacena;
        this.setState({
            pravilaOznacena: pravilaSelected,
            pravilaJednomOznacena: true
        });
    }
    render() {
        if (this.props.userChecked && this.props.user && this.props.user.obavijesti.indexOf(this.const_PokerStart) != -1)
            return <div className="overlay" style={{ fontSize: '1rem' }}>
                <div className="overlay--content">
                    <div className="margin-bottom">
                        <span className="text-xlarge text-xbold">
                            Dobrodošli u SuperSport Texas Hold'em Poker
                            </span>
                    </div>
                    <div className="margin-bottom">
                        <span className="">
                            Ekipa je već tu! Ti si na potezu.
                            </span>
                    </div>
                    <div className="margin-bottom">
                        <span className="">
                            <span className="text-bold text-red">Novost</span> u vašem Računu je <span className="text-bold">prijenos novca</span> iz Glavnog računa u Casino račun bez naknade.
                            </span>
                    </div>
                    <div className="margin-bottom">
                        <span className="">
                            <span className="text-bold">Da biste igrali Poker, na Casino računu morate imati novac.</span>
                        </span>
                    </div>
                    <div className="margin-bottom ">
                        <hr />
                    </div>

                    <div className="margin-bottom">
                        <span className="">
                            <button className="link padding-nula" onClick={this.togglePravila}><span className={'icon ' + (this.state.pravilaOznacena ? 'ico-check-on  text-dark-blue' : 'ico-check-off text-gray')}></span></button>&nbsp;
                                Razumijem i prihvaćam <a href={casino.config.urls.pravilaPoker} className="link blue"><span>Pravila</span></a> i <a href={casino.config.urls.zastitaPrivatnosti} className="link blue"><span>Opće odredbe o zaštiti osobnih podataka</span></a>.
                            </span>
                    </div>
                    <div className={this.state.pravilaJednomOznacena ? '' : 'hidden'}>
                        <div className="margin-bottom ">
                            <hr />
                        </div>

                        <div className="margin-bottom-small">
                            <span className="">
                                Trenutni saldo Casino računa iznosi: <span className="text-bold">{this.props.user && casino.utils.numberWithCurrencyFromated(this.props.user.casinoRaspolozivo, this.props.user.valuta)}.</span>
                            </span>
                        </div>
                        <div className="margin-bottom">
                            <NavLink onClick={() => this.sakrijObavijest(this.const_PokerStart)} to="/poker/account" className="link blue"><span>Prenesi novac u Casino</span></NavLink>
                        </div>
                        <br />
                        <div className="margin-bottom">
                            <button disabled={!this.state.pravilaOznacena} onClick={() => this.sakrijObavijest(this.const_PokerStart)} className="link blue padding-nula"><span className="text-bold">U REDU</span></button>
                        </div>

                    </div>
                    <br />
                </div>
            </div>


        return null;
    }
};
